export const selectors$1b = {
  body: 'body',
  main: '[data-main]',
  collectionFilters: '[data-collection-filters]',
  footer: '[data-section-type*="footer"]',
  header: '[data-header-height]',
  stickyHeader: '[data-site-header][data-position="fixed"]',
  announcementBar: '[data-announcement-bar]',
  collectionStickyBar: '[data-collection-sticky-bar]',
  logoTextLink: '[data-logo-text-link]',
};

export const selectors$X = {
  swatch: '[data-swatch]',
  swatchColor: '[data-swatch-color]',
  productBlock: '[data-product-block]',
  productImage: '[data-product-image]',
  productImageSecondary: '[data-product-image-secondary]',
  productImageHover: '[data-product-image-hover]',
  quickView: '[data-button-quick-view]',
  gridImage: '[data-grid-image]',
  link: '[data-grid-link]',
  swatchesMore: '[data-swatches-more]',
  sectionType: '[data-section-type]',
  swatchesContainer: '[data-swatches-container]',
  swatchesLabel: '[data-swatches-label]',
  swatchesButton: '[data-swatches-button]',
  selectorWrapper: '[data-option-position]',
  slider: '[data-slider]',
};

 export const selectors$1a = {
  overflowBackground: '[data-overflow-background]',
  overflowFrame: '[data-overflow-frame]',
  overflowContent: '[data-overflow-content]',
  overflowContainer: '[data-overflow-container]',
  overflowWrapper: '[data-overflow-wrapper]',
};

export const selectors$19 = {
  img: 'img.is-loading',
  section: '[data-section-type]',
};

export const selectors$_ = {
  tooltip: '[data-tooltip]',
  tooltipContainer: '[data-tooltip-container]',
  tooltipArrow: '[data-tooltip-arrow]',
  aos: '[data-aos]',
};

export const selectors$N = {
  form: 'form',
  popoutWrapper: '[data-popout]',
  popoutList: '[data-popout-list]',
  popoutToggle: '[data-popout-toggle]',
  popoutInput: '[data-popout-input]',
  popoutOptions: '[data-popout-option]',
  popoutText: '[data-popout-text]',
  ariaCurrent: '[aria-current]',
  productGridImage: '[data-product-image]',
  productGrid: '[data-product-grid-item]',
};

export const selectors$M = {
  addToCart: '[data-add-to-cart]',
  deferredMedia: '[data-deferred-media]',
  deferredMediaButton: '[data-deferred-media-button]',
  popupClose: '[data-popup-close]',
  popout: '[data-popout]',
  quickViewInner: '[data-quick-view-inner]',
  quickViewItemHolder: '[data-quick-view-item-holder]',
  product: '[data-product]',
  productForm: '[data-product-form]',
  productMediaSlider: '[data-product-single-media-slider]',
  productMediaWrapper: '[data-product-single-media-wrapper]',
  productModel: '[data-model]',
  productJSON: '[data-product-json]',
  quickViewFootInner: '[data-quick-view-foot-inner]',
  shopTheLookThumb: '[data-shop-the-look-thumb]',
  tooltip: '[data-tooltip]',
  drawerToggle: '[data-drawer-toggle]',
};

export const selectors$L = {
  popupContainer: '.pswp',
  popupCloseBtn: '.pswp__custom-close',
  popupIframe: 'iframe, video',
  popupCustomIframe: '.pswp__custom-iframe',
  popupThumbs: '.pswp__thumbs',
  popupButtons: '.pswp__button, .pswp__caption-close',
  product: '[data-product]',
  productJSON: '[data-product-json]',
};

export const selectors$J = {
  outerSection: '[data-section-id]',
  aos: '[data-aos]',
  additionalCheckoutButtons: '[data-additional-checkout-button]',
  apiContent: '[data-api-content]',
  apiLineItems: '[data-api-line-items]',
  apiUpsellItems: '[data-api-upsell-items]',
  apiCartPrice: '[data-api-cart-price]',
  buttonAddToCart: '[data-add-to-cart]',
  upsellButtonByHandle: '[data-handle]',
  cartCloseError: '[data-cart-error-close]',
  cartDrawer: '[data-cart-drawer]',
  cartDrawerTemplate: '[data-cart-drawer-template]',
  cartDrawerToggle: '[data-cart-drawer-toggle]',
  cartDrawerBody: '[data-cart-drawer-body]',
  cartErrors: '[data-cart-errors]',
  cartForm: '[data-cart-form]',
  cartTermsCheckbox: '[data-cart-acceptance-checkbox]',
  cartCheckoutButtonWrapper: '[data-cart-checkout-buttons]',
  cartCheckoutButton: '[data-cart-checkout-button]',
  cartItemRemove: '[data-item-remove]',
  cartItemsQty: '[data-cart-items-qty]',
  cartTotal: '[data-cart-total]',
  cartTotalPrice: '[data-cart-total-price]',
  cartMessage: '[data-cart-message]',
  cartMessageDefault: '[data-message-default]',
  cartPage: '[data-cart-page]',
  cartProgress: '[data-cart-message-progress]',
  emptyMessage: '[data-empty-message]',
  buttonHolder: '[data-foot-holder]',
  item: '[data-cart-item]',
  itemsHolder: '[data-items-holder]',
  itemsWrapper: '[data-items-wrapper]',
  formCloseError: '[data-close-error]',
  formErrorsContainer: '[data-cart-errors-container]',
  upsellHolder: '[data-upsell-holder]',
  errorMessage: '[data-error-message]',
  termsErrorMessage: '[data-terms-error-message]',
  pairProductsHolder: '[data-pair-products-holder]',
  pairProducts: '[data-pair-products]',
  priceHolder: '[data-cart-price-holder]',
  leftToSpend: '[data-left-to-spend]',
  quickBuyForm: '[data-quickbuy-form]',
  qtyInput: '[data-quantity-field]',
  productMediaContainer: '[data-product-media-container]',
  formWrapper: '[data-form-wrapper]',
  productForm: '[data-product-form]',
  popupQuickView: '.popup-quick-view',
  popupClose: '[data-popup-close]',
  error: '[data-error]',
  quickViewOnboarding: '[data-quick-view-onboarding]',
  flickityEnabled: '.flickity-enabled',
  stickyButton: '[data-sticky-add-to-cart]',
};

export const selectors$I = {
  scrollToTop: '[data-scroll-top-button]',
};

export const selectors$H = {
  details: 'details',
  popdownBody: '[data-popdown-body]',
  popdownClose: '[data-popdown-close]',
  popdownToggle: '[data-popdown-toggle]',
  searchFormInner: '[data-search-form-inner]',
  input: 'input:not([type="hidden"])',
  popularSearchesLink: '[data-popular-searches-link]',
  header: '[data-site-header]',
  nav: '[data-nav]',
  navItemsCompress: '[data-nav-items-compress]',
  navIcons: '[data-nav-icons]',
  mobileMenu: '[data-mobile-menu]',
  predictiveSearch: 'predictive-search',
  searchForm: 'search-form',
};

export const selectors$G = {
  templateAddresses: '.template-customers-addresses',
  accountForm: '[data-form]',
  addressNewForm: '[data-form-new]',
  btnNew: '[data-button-new]',
  btnEdit: '[data-button-edit]',
  btnDelete: '[data-button-delete]',
  btnCancel: '[data-button-cancel]',
  editAddress: 'data-form-edit',
  addressCountryNew: 'AddressCountryNew',
  addressProvinceNew: 'AddressProvinceNew',
  addressProvinceContainerNew: 'AddressProvinceContainerNew',
  addressCountryOption: '[data-country-option]',
  addressCountry: 'AddressCountry',
  addressProvince: 'AddressProvince',
  addressProvinceContainer: 'AddressProvinceContainer',
  requiredInputs: 'input[type="text"]:not(.optional)',
};

export const selectors$F = {
  form: '[data-account-form]',
  showReset: '[data-show-reset]',
  hideReset: '[data-hide-reset]',
  recover: '[data-recover-password]',
  login: '[data-login-form]',
  recoverSuccess: '[data-recover-success]',
  recoverSuccessText: '[data-recover-success-text]',
  recoverHash: '#recover',
};

export const selectors$E = {
  frame: '[data-ticker-frame]',
  scale: '[data-ticker-scale]',
  text: '[data-ticker-text]',
  clone: 'data-clone',
};

export const selectors$D = {
  announcement: '[data-announcement]',
  announcementSlide: '[data-announcement-slide]',
  frame: '[data-ticker-frame]',
  slide: '[data-slide]',
  slider: '[data-slider]',
  tickerScale: '[data-ticker-scale]',
  tickerText: '[data-ticker-text]',
};

export const selectors$C = {
  disclosureWrappper: '[data-hover-disclosure]',
  header: '[data-site-header]',
  link: '[data-top-link]',
  headerBackground: '[data-header-background]',
  navItem: '[data-nav-item]',
};

export const selectors$B = {
  header: '[data-site-header]',
  announcementBar: '[data-announcement-wrapper]',
  collectionFilters: '[data-collection-filters]',
  logoTextLink: '[data-logo-text-link]',
  mobileNavDropdownTrigger: '[data-collapsible-trigger]',
  navDrawer: '#nav-drawer',
  drawer: '[data-drawer]',
  drawerToggle: '[data-drawer-toggle]',
  popdownToggle: '[data-popdown-toggle]',
  mobileMenu: '[data-mobile-menu]',
  nav: '[data-nav]',
  navIcons: '[data-nav-icons]',
  navItem: '[data-nav-item]',
  navLinkMobile: '[data-nav-link-mobile]',
  navSearchOpen: '[data-nav-search-open]',
  wrapper: '[data-wrapper]',
  headerBackground: '[data-header-background]',
  cartPage: '[data-cart-page]',
  widthContent: '[data-takes-space]',
};

export const selectors$A = {
  trigger: '[data-collapsible-trigger]',
};

export const selectors$z = {
  button: '[data-share-button]',
  tooltip: '[data-share-button-tooltip]',
};

export const selectors$y = {
  videoPlay: '[data-video-play]',
};

export const selectors$x = {
  header: '[data-site-header]',
  main: '[data-main]',
};

export const selectors$w = {
  imageWrapper: '[data-banner-image]',
  lazyImage: '.lazy-image',
};

export const selectors$v = {
  scrollSpy: '[data-scroll-spy]',
};

export const selectors$u = {
  banner: '[data-banner]',
  sliderContent: '[data-slider-content]',
  sliderMedia: '[data-slider-media]',
  links: 'a, button',
};

export const selectors$t = {
  slider: '[data-slider]',
  sliderItem: '[data-slider-item]',
  sliderItemImage: '[data-media-container]',
  links: 'a, button',
  flickityButton: '.flickity-button',
};

export const selectors$s = {
  formMessageClose: '[data-form-message-close]',
  formMessageWrapper: '[data-form-message]',
};

export const selectors$r = {
  time: 'time',
  days: '[data-days]',
  hours: '[data-hours]',
  minutes: '[data-minutes]',
  seconds: '[data-seconds]',
  sectionType: '[data-section-type]',
  shopifySection: '.shopify-section',
  aosItem: '[data-aos]',
};

export const selectors$q = {
  videoId: '[data-video-id]',
  videoPlayer: '[data-video-player]',
  videoTemplate: '[data-video-template]',
  videoAutoplay: '[data-video-autoplay]',
  videoWrapper: '[data-video-wrapper]',
  videoPlayButton: '[data-video-bg-play]',
};

export const selectors$p = {
  newsletterForm: '[data-newsletter-form]',
  popup: '[data-popup]',
};

export const selectors$o = {
  product: '[data-product]',
  productSlider: '[data-slider]',
  productSlide: '[data-slide]',
  productGridItemImage: '[data-product-media-container]',
  flickityButton: '.flickity-button',
  item: '[data-slide]',
  links: 'a, button',
};

export const selectors$n = {
  slider: '[data-slider]',
  sliderItem: '[data-slide]',
  productGridItemImage: '[data-product-media-container]',
  links: 'a, button',
  flickityButton: '.flickity-button',
  promo: '[data-promo]',
  productGridItems: '[data-product-block]',
};

export const selectors$m = {
  shopPayWrapper: '[data-shop-pay-wrapper]',
  shopLoginButton: 'shop-login-button',
  shopFollowButton: 'shop-follow-button',
  followOnShopButton: 'follow-on-shop-button',
  heartIcon: 'heart-icon',
  shopLogo: 'shop-logo',
};

export const selectors$l = {
  trigger: '[data-collapsible-trigger-mobile]',
};

export const selectors$k = {
  slider: '[data-slider]',
};

export const selectors$j = {
  item: '[data-accordion-item]',
  button: '[data-accordion-button]',
};

export const selectors$i = {
  slider: '[data-slider-gallery]',
  sliderNav: '[data-slider-info]',
  item: '[data-slide-item]',
};

export const selectors$h = {
  slider: '[data-slider]',
  sliderItem: '[data-slide-item]',
  pointer: '[data-pointer]',
  productGridItemImage: '[data-product-media-container]',
  quickViewItemHolder: '[data-quick-view-item-holder]',
  flickityButton: '.flickity-button',
  links: 'a, button',
  tooltip: '[data-tooltip]',
};

export const selectors$g = {
  grid: '[data-grid]',
};

export const selectors$f = {
  parallaxElement: '[data-parallax]',
};

export const selectors$e = {
  toggleAdmin: '[data-toggle-admin]',
  toggleNewsletter: '[data-toggle-newsletter]',
  adminForm: '[data-form-admin]',
  newsletterForm: '[data-form-newsletter]',
};

export const selectors$d = {
  largePromo: '[data-large-promo]',
  largePromoInner: '[data-large-promo-inner]',
  tracking: '[data-tracking-consent]',
  trackingInner: '[data-tracking-consent-inner]',
  trackingAccept: '[data-confirm-cookies]',
  popupBar: '[data-popup-bar]',
  popupBarHolder: '[data-popup-bar-holder]',
  popupBarToggle: '[data-popup-bar-toggle]',
  popupBody: '[data-popup-body]',
  popupClose: '[data-popup-close]',
  popupUnderlay: '[data-popup-underlay]',
  newsletterForm: '[data-newsletter-form]',
};

export const selectors$c = {
  pressItems: '[data-press-items]',
  logoSlider: '[data-logo-slider]',
  logoSlide: '[data-logo-slide]',
  links: 'a, button',
};

export const selectors$b = {
  slideshow: '[data-product-single-media-slider]',
  productInfo: '[data-product-info]',
  headerSticky: '[data-header-sticky]',
  headerHeight: '[data-header-height]',
};

export const selectors$a = {
  mediaContainer: '[data-product-single-media-group]',
  productMediaSlider: '[data-product-single-media-slider]',
  zoomWrapper: '[data-zoom-wrapper]',
};

export const selectors$9 = {
  complementaryProducts: '[data-complementary-products]',
  buttonQuickView: '[data-button-quick-view]',
};

export const selectors$8 = {
  recipientCheckbox: '[data-recipient-checkbox]',
  recipientEmail: '[data-recipient-email]',
  recipientName: '[data-recipient-name]',
  recipientMessage: '[data-recipient-message]',
  recipientSendOn: '[data-recipient-send-on]',
  recipientControl: '[data-recipient-control]',
  recipientOffset: '[data-recipient-offset]',
  productForm: '[data-product-form]',
  cartDrawer: '[data-cart-drawer]',
};

export const selectors$7 = {
  option: '[data-option]',
  popout: '[data-popout]',
  productMediaSlider: '[data-product-single-media-slider]',
  productMediaThumb: '[data-thumbnail-id]',
  productMediaThumbs: '[data-product-single-media-thumbs]',
  productMediaWrapper: '[data-product-single-media-wrapper]',
  productModel: '[data-model]',
  productSingleThumbnailLink: '.product-single__thumbnail-link',
  deferredMedia: '[data-deferred-media]',
  deferredMediaButton: '[data-deferred-media-button]',
  modalScrollContainer: '[data-tabs-holder]',
  tooltip: '[data-tooltip]',
  productRating: '[data-product-rating]',
  productReviews: '#shopify-product-reviews',
  links: 'a, button',
  upsellProduct: '[data-upsell-holder]',
  upsellProductSlider: '[data-upsell-slider]',
  featureSlider: '[data-slider]',
  productJson: '[data-product-json]',
};

export const selectors$6 = {
  deferredMedia: '[data-deferred-media]',
  deferredMediaButton: '[data-deferred-media-button]',
  productContentWrapper: '[data-product-content-wrapper]',
  productMediaWrapper: '[data-product-single-media-wrapper]',
  productModel: '[data-model]',
  productLink: '[data-product-link]',
  productSingleMediaImage: '[data-product-single-media-image]',
  sliderContents: '[data-slider-contents]',
  sliderImages: '[data-slider-images]',
  tabButton: '[data-tab-button]',
  tabItem: '[data-tab-item]',
  circleText: '[data-circle-text]',
};

export const selectors$5 = {
  product: '[data-product-block]',
  relatedProducts: '[data-related-products]',
  recentlyViewed: '[data-recent-wrapper]',
  recentlyViewedWrapper: '[data-recently-viewed-wrapper]',
  slider: '[data-slider]',
  aos: '[data-aos]',
  tabsHolder: '[data-tabs-holder]',
  tabsLink: '[data-tabs-link]',
  tab: '[data-tab]',
  tooltip: '[data-tooltip]',
};


export const selectors$4 = {
  slider: '[data-slider]',
  sliderItem: '[data-item]',
  buttonProductsShow: '[data-button-show]',
  buttonProductsHide: '[data-button-hide]',
  itemProducts: '[data-item-products]',
  itemProductSlider: '[data-item-products-slider]',
  itemProduct: '[data-item-product]',
  links: 'a, button',
};


export const selectors$3 = {
  arrowScrollDown: '[data-scroll-down]',
  header: '[data-site-header]',
  item: '[data-slide]',
  links: 'a, button',
  slider: '[data-slider]',
  lazyImage: '.lazy-image',
};

export const selectors$2 = {
  wrapper: '[data-sticky-wrapper]',
  aside: '[data-sticky-aside]',
  inner: '[data-sticky-inner]',
  content: '[data-sticky-content]',
  text: '[data-sticky-text]',
  textInner: '[data-sticky-text-inner]',
  image: '[data-sticky-image]',
  images: '[data-sticky-images]',
  imageWrapper: '.image-wrapper',
  dot: '[data-sticky-dot]',
};

export const selectors$1 = {
  slider: '[data-slider]',
  item: '[data-item]',
};

export const selectors$Y = {
  idInput: '[name="id"]',
  planInput: '[name="selling_plan"]',
  optionInput: '[name^="options"]',
  quantityInput: '[name="quantity"]',
  propertyInput: '[name^="properties"]',
};

export const selectors$V = {
  ajaxinateContainer: '#AjaxinateLoop',
  ajaxinatePagination: '#AjaxinatePagination',
};

export const selectors$15 = {
  single: '[data-collapsible-single]', // Add this attribute when we want only one item expanded at the same time
  trigger: '[data-collapsible-trigger]',
  content: '[data-collapsible-content]',
};

export const selectors$$ = {
  scrollbar: '[data-custom-scrollbar]',
  scrollbarItems: '[data-custom-scrollbar-items]',
  scrollbarThumb: '[data-custom-scrollbar-thumb]',
  current: '.current',
};

export const selectors$18 = {
  img: 'img',
  template: 'template',
  shopifySection: '.shopify-section',
  deferredContent: '[data-deferred-content]',
  reloadSrcsetException: '[data-product-image]',
};

export const selectors$S = {
  drawer: '[data-drawer]',
  drawerToggle: '[data-drawer-toggle]',
  scroller: '[data-scroll]',
  quickviewItem: '[data-quick-view-item]',
  tabsLink: '[data-tabs-link]',
};

export const selectors$U = {
  buttons: 'button',
  toggleFilters: '[data-toggle-filters]',
  closeFilters: '[data-close-filters]',
  openFilters: '[data-open-filters]',
  collectionWrapper: '[data-collection-wrapper]',
  collapsibleTrigger: '[data-collapsible-trigger]',
  sortToggle: '[data-sort-toggle]',
  collectionSortOptions: '[data-collection-sort-options]',
  inputs: 'input, select, label, textarea',
  inputSort: '[data-input-sort]',
  filters: '[data-collection-filters]',
  filtersWrapper: '[data-collection-filters-wrapper]',
  filtersList: '[data-collection-filters-list]',
  filtersStickyBar: '[data-collection-sticky-bar]',
  filter: '[data-collection-filter]',
  filterTag: '[data-collection-filter-tag]',
  filterTagButton: '[data-collection-filter-tag-button]',
  filtersForm: '[data-collection-filters-form]',
  filterResetButton: '[data-filter-reset-button]',
  filterTagClearButton: '[data-filter-tag-reset-button]',
  popupsSection: '[data-section-type="popups"]',
  productGrid: '[data-collection-products]',
  productsCount: '[data-products-count]',
  priceMin: '[data-field-price-min]',
  priceMax: '[data-field-price-max]',
  rangeMin: '[data-se-min-value]',
  rangeMax: '[data-se-max-value]',
  rangeMinValue: 'data-se-min-value',
  rangeMaxValue: 'data-se-max-value',
  rangeMinDefault: 'data-se-min',
  rangeMaxDefault: 'data-se-max',
  tooltip: '[data-tooltip]',
  tooltipContainer: '[data-tooltip-container]',
  showMore: '[data-show-more]',
  showMoreActions: '[data-show-more-actions]',
  showMoreContainer: '[data-show-more-container]',
  showMoreTrigger: '[data-show-more-trigger]',
  searchPerformed: '[data-search-performed]',
  searchForm: '[data-search-form]',
  scrollable: '[data-custom-scrollbar]',
};

export const selectors$11 = {
  notificationForm: '[data-notification-form]',
  notification: '[data-notification]',
  popupClose: '[data-popup-close]',
};

export const selectors$13 = {
  videoIframe: '[data-video-id]',
};

export const selectors$12 = {
  videoIframe: '[data-video-id]',
  videoWrapper: '.video-wrapper',
  youtubeWrapper: '[data-youtube-wrapper]',
};

export const selectors$R = {
  list: '[data-store-availability-list]',
};

export const selectors$16 = {
  predictiveSearch: 'predictive-search',
  sectionPredictiveSearch: '#shopify-section-api-predictive-search',
  predictiveSearchResults: '[data-predictive-search-results]',
  predictiveSearchStatus: '[data-predictive-search-status]',
  searchResultsLiveRegion: '[data-predictive-search-live-region-count-value]',
  searchResultsWrapper: '[data-search-results-wrapper]',
};


export const selectors$O = {
  product: '[data-product]',
  productForm: '[data-product-form]',
  addToCart: '[data-add-to-cart]',
  addToCartText: '[data-add-to-cart-text]',
  buyItNow: '[data-buy-it-now]',
  comparePrice: '[data-compare-price]',
  formWrapper: '[data-form-wrapper]',
  header: '[data-site-header]',
  originalSelectorId: '[data-product-select]',
  preOrderTag: '_preorder',
  priceWrapper: '[data-price-wrapper]',
  priceOffWrap: '[data-price-off]',
  priceOffType: '[data-price-off-type]',
  priceOffAmount: '[data-price-off-amount]',
  productSlide: '[data-product-slide]',
  productImage: '[data-product-image]',
  productMediaSlider: '[data-product-single-media-slider]',
  productJson: '[data-product-json]',
  productPrice: '[data-product-price]',
  unitPrice: '[data-product-unit-price]',
  unitBase: '[data-product-base]',
  unitWrapper: '[data-product-unit]',
  subPrices: '[data-subscription-watch-price]',
  subSelectors: '[data-subscription-selectors]',
  subsToggle: '[data-toggles-group]',
  subsChild: 'data-group-toggle',
  subDescription: '[data-plan-description]',
  remainingCount: '[data-remaining-count]',
  remainingWrapper: '[data-remaining-wrapper]',
  remainingJSON: '[data-product-remaining-json]',
  idInput: '[name="id"]',
  storeAvailabilityContainer: '[data-store-availability-container]',
  upsellButton: '[data-upsell-btn]',
  sectionNode: '.shopify-section',
  quickViewItem: '[data-quick-view-item]',
  notificationButtonText: '[data-notification-button-text]',
  swatchesContainer: '[data-swatches-container]',
  swatchesMore: '[data-swatches-more]',
  selectorWrapper: '[data-option-position]',
  shopifyPaymentButton: '.shopify-payment-button__button',
  paymentButton: '[role="button"], [type="submit"], form',
  disabled: '[disabled]',
  variantTitle: '[data-variant-title]',
  stickyAtc: '[data-sticky-atc]',
  stickyAtcButton: '[data-sticky-add-to-cart]',
};

export const selectors$W = {
  slider: '[data-slider]',
  productMediaContainer: '[data-product-media-container]',
  productMediaSlider: '[data-product-media-slideshow]',
  productMediaSlide: '[data-product-media-slideshow-slide]',
  progressBar: '[data-product-slideshow-progress]',
  flickityButton: '.flickity-button',
  popupProduct: '[data-product]',
  popupClose: '[data-popup-close]',
};

export const selectors$10 = {
  deferredMedia: '[data-deferred-media]',
  deferredMediaButton: '[data-deferred-media-button]',
  productMediaWrapper: '[data-product-single-media-wrapper]',
  mediaContainer: '[data-video]',
  mediaHidden: '.media--hidden',
};

export const selectors$14 = {
  quantityHolder: '[data-quantity-holder]',
  quantityField: '[data-quantity-field]',
  quantityButton: '[data-quantity-button]',
  quantityMinusButton: '[data-quantity-minus]',
  quantityPlusButton: '[data-quantity-plus]',
};

export const selectors$K = {
  buttonQuickView: '[data-button-quick-view]',
  quickViewItemsTemplate: '[data-quick-view-items-template]',
  cartDrawer: '[data-cart-drawer]',
  shopTheLookQuickViewButton: '[data-shop-the-look-quick-view-button]',
  shopTheLookThumb: '[data-shop-the-look-thumb]',
  quickViewItemHolder: '[data-quick-view-item-holder]',
};

export const selectors$Z = {
  rangeSlider: '[data-range-slider]',
  rangeDotLeft: '[data-range-left]',
  rangeDotRight: '[data-range-right]',
  rangeLine: '[data-range-line]',
  rangeHolder: '[data-range-holder]',
  dataMin: 'data-se-min',
  dataMax: 'data-se-max',
  dataMinValue: 'data-se-min-value',
  dataMaxValue: 'data-se-max-value',
  dataStep: 'data-se-step',
  dataFilterUpdate: 'data-range-filter-update',
  priceMin: '[data-field-price-min]',
  priceMax: '[data-field-price-max]',
};

export const selectors$17 = {
  inputSearch: 'input[type="search"]',
  inputType: 'input[name="type"]',
  form: 'form',
  allVisibleElements: '[role="option"]',
  ariaSelected: '[aria-selected="true"]',
  selectedOption: '[aria-selected="true"] a, button[aria-selected="true"]',
  popularSearches: '[data-popular-searches]',
  popdownBody: '[data-popdown-body]',
  mainInputSearch: '[data-main-input-search]',
  predictiveSearchResults: '[data-predictive-search-results]',
  predictiveSearch: 'predictive-search',
  searchForm: 'search-form',
};

export const selectors$P = {
  form: '[data-product-form]',
  optionPosition: '[data-option-position]',
  optionInput: '[name^="options"], [data-popout-option]',
};

export const selectors$Q = {
  body: 'body',
  storeAvailabilityModal: '[data-store-availability-modal]',
  storeAvailabilityModalOpen: '[data-store-availability-modal-open]',
  storeAvailabilityModalClose: '[data-store-availability-modal-close]',
  storeAvailabilityModalProductTitle: '[data-store-availability-modal-product__title]',
};

export const selectors$T = {
  aosItem: '[data-aos]',
  tabsLink: '[data-tabs-link]',
  tab: '[data-tab]',
  tabRef: '[data-tab-ref]',
  scrollable: '[data-custom-scrollbar]',
  scrollableHolder: '[data-custom-scrollbar-holder]',
  slider: '[data-slider]',
  tabsContents: '[data-tabs-contents]',
  searchForm: '[data-search-form]',
  allTypesContainer: '[data-all-types-container]',
  filtersForm: '[data-collection-filters-form]',
  currentPage: '[data-current-page]',
  tooltip: '[data-tooltip]',
  productGrid: '[data-collection-products]',
  ajaxinateContainer: '#AjaxinateLoop',
  ajaxinatePagination: '#AjaxinatePagination',
};

export const selectors$1c = {
  body: 'body',
  main: '[data-main]',
  header: '[data-site-header]',
  preventTransparentHeader: '[data-prevent-transparent-header]',
};

export const selectors = {
  inPageLink: '[data-skip-content]',
  linkesWithOnlyHash: 'a[href="#"]',
};